export const GET_GEO_CHECKLIST = 'GET_GEO_CHECKLIST';
export const GET_GEO_CHECKLIST_CATALOG = 'GET_GEO_CHECKLIST_CATALOG';
